/**
 * MONTY — COLLAPSIBLE ROW
 * L'animation d'ouverture et de fermeture des lignes depliantes.
 *
 * Le balisage est un <details> natif : sans ce script la ligne s'ouvre et se
 * ferme quand meme, d'un coup. Le script ne fait qu'une chose, animer la
 * hauteur du panneau, puis rendre la main au navigateur — aucune hauteur
 * n'est laissee en dur, donc la ligne se remet d'aplomb toute seule quand la
 * fenetre change ou que le texte se recompose.
 *
 * Tout passe par la delegation sur le document : rien a raccrocher quand
 * l'editeur recharge une section.
 */
(function () {
  'use strict';

  if (window.montyCollapsible) return;
  window.montyCollapsible = true;

  var COURBE = 'cubic-bezier(.32, .72, 0, 1)';

  function mouvementReduit() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function panneau(ligne) {
    return ligne.querySelector('[data-mc-panel]');
  }

  function duree(ligne) {
    var d = parseInt(ligne.getAttribute('data-mc-speed'), 10);
    return isFinite(d) && d > 0 ? d : 320;
  }

  function arrete(ligne) {
    if (ligne.__mcAnim) {
      ligne.__mcAnim.cancel();
      ligne.__mcAnim = null;
    }
    if (ligne.__mcFin) {
      window.clearTimeout(ligne.__mcFin);
      ligne.__mcFin = 0;
    }
  }

  /* Le rideau de fin. L'evenement « finish » d'une animation n'est pas emis
     tant que la page est masquee : un visiteur qui referme une ligne puis
     change d'onglet laisserait le <details> ouvert. On double donc l'ecoute
     d'une minuterie, et le premier arrive fait le travail — le garde-fou sur
     l'animation courante le rend sans effet si une autre a pris la main. */
  function aLaFin(ligne, anim, faire) {
    function une_fois() {
      if (ligne.__mcAnim !== anim) return;
      ligne.__mcAnim = null;
      if (ligne.__mcFin) {
        window.clearTimeout(ligne.__mcFin);
        ligne.__mcFin = 0;
      }
      faire();
    }
    anim.addEventListener('finish', une_fois);
    ligne.__mcFin = window.setTimeout(une_fois, duree(ligne) + 40);
  }

  /* L'ouverture : on ouvre pour de vrai d'abord, sinon le panneau ne serait
     pas rendu et on ne pourrait pas le mesurer. */
  function ouvre(ligne) {
    var p = panneau(ligne);
    if (!p) return;
    arrete(ligne);

    ligne.open = true;
    ligne.classList.add('is-open');

    if (mouvementReduit()) return;

    var h = p.scrollHeight;
    var anim = p.animate(
      [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }],
      { duration: duree(ligne), easing: COURBE }
    );
    ligne.__mcAnim = anim;
    aLaFin(ligne, anim, function () {});
  }

  /* La fermeture : on anime d'abord, on ferme a l'arrivee. Une animation
     annulee en route ne doit pas refermer la ligne, d'ou le drapeau. */
  function ferme(ligne) {
    var p = panneau(ligne);
    if (!p) return;
    arrete(ligne);

    ligne.classList.remove('is-open');

    if (mouvementReduit()) {
      ligne.open = false;
      return;
    }

    var h = p.scrollHeight;
    var anim = p.animate(
      [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
      { duration: duree(ligne), easing: COURBE }
    );
    ligne.__mcAnim = anim;
    aLaFin(ligne, anim, function () {
      ligne.open = false;
    });
  }

  function bascule(ligne) {
    if (ligne.classList.contains('is-open')) {
      ferme(ligne);
    } else {
      ouvre(ligne);
    }
  }

  /* « Une seule a la fois » : les voisines sont les autres lignes du meme
     groupe, sinon de la meme colonne, sinon de la page. */
  function voisines(ligne) {
    var cadre = ligne.closest('.monty-collapsible-group')
      || ligne.closest('.product-info')
      || document;
    return cadre.querySelectorAll('[data-mc-row]');
  }

  document.addEventListener('click', function (e) {
    var tete = e.target.closest && e.target.closest('[data-mc-head]');
    if (!tete) return;

    var ligne = tete.parentElement;
    if (!ligne || !ligne.hasAttribute('data-mc-row')) return;

    /* Un lien dans le titre garde son role propre. */
    if (e.target.closest('a[href]')) return;

    /* Le navigateur basculerait « open » tout seul : on lui reprend la main
       pour pouvoir animer, et pour fermer a la fin et non au debut. */
    e.preventDefault();

    var ouvrir = !ligne.classList.contains('is-open');

    if (ouvrir && ligne.hasAttribute('data-mc-single')) {
      var autres = voisines(ligne);
      for (var i = 0; i < autres.length; i++) {
        if (autres[i] !== ligne && autres[i].classList.contains('is-open')) {
          ferme(autres[i]);
        }
      }
    }

    bascule(ligne);
  });

  /* L'etat de depart peut venir du balisage : on remet la classe d'aplomb au
     cas ou le navigateur aurait restaure un « open » a la navigation. */
  function tout() {
    var lignes = document.querySelectorAll('[data-mc-row]');
    for (var i = 0; i < lignes.length; i++) {
      lignes[i].classList.toggle('is-open', lignes[i].open);
    }
  }

  document.addEventListener('shopify:section:load', tout);
  document.addEventListener('shopify:block:select', function (e) {
    var ligne = e.target.querySelector ? e.target.querySelector('[data-mc-row]') : null;
    if (!ligne && e.target.closest) ligne = e.target.closest('[data-mc-row]');
    if (ligne && !ligne.classList.contains('is-open')) ouvre(ligne);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tout);
  } else {
    tout();
  }
})();
